<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Configure Capacity</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="activeModal.dismiss()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <p class="mb-2 text-truncate" [title]="productName">{{ productName }}</p>
  <form (ngSubmit)="confirm()">
    <div class="d-flex align-items-center gap-2">
      <label for="floating-capacity" class="form-label text-nowrap mb-0">Capacity:</label>
      <input
        type="number"
        min="0"
        step="1"
        class="form-control"
        id="floating-capacity"
        name="capacity"
        [(ngModel)]="capacity"
      />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="confirm()">Save</button>
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
